module.exports = __webpack_public_path__ + "img/sz.1cb96ec5.svg";